<template>
  <transition name="modal">
    <div v-if="show" @keyup.esc="$emit('removeModal')">
      <div :class="[{'modal-mask': show_modal_mask}, {'modal-add-sidebar': show_modal_sidebar}]">
        <div class="modal-wrapper">
          <div class="modal-container"
               v-on-clickaway="clickAway">
            <div class="modal-left">
              <div class="modal-header">
                <slot name="header">default header</slot>
                <div class="font-large close-cross icon__bg-circle js-modalCloseEvent" @click="removeModal"><span class="icon-cross2 pointer js-modalCloseEvent"></span></div>
              </div>
              <div class="modal-body">
                <slot name="body">default body</slot>
              </div>
              <div class="modal-footer">
                <slot name="footer">
                  <button class="bttn bttn_simple right marg-10">
                    Ok
                  </button>
                  <button class="bttn bttn_simple right marg-10">
                    Gem
                  </button>
                </slot>
              </div>
            </div>
            <div class="modal-right" v-if="show_modal_sidebar">
              <div class="modal-sidebar">
                <slot name="sidebar">
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import {mixin as clickaway} from 'vue-clickaway'
  import eventbus from '../../eventbus'

  export default {
    mixins: [clickaway],
    props: {
      show: {
        type: Boolean,
        default: false
      },
      // if true add @click.stop on open button in parent
      close_on_click_away: {
        type: Boolean,
        default: false
      },
      show_modal_mask: {
        type: Boolean,
        default: true
      },
      show_modal_sidebar: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      show () {
        // add overflow hidden on show
        const body = document.querySelector('body')
        if (this.show) {
          eventbus.createModalOpen = true
          body.classList.add('no-scroll')
        } else {
          this.removeModal()
        }
      }
    },
    methods: {
      setShowModal () {
        this.show = true
      },
      removeModal () {
        const body = document.querySelector('body')
        this.$emit('close')
        body.classList.remove('no-scroll')
        eventbus.createModalOpen = false
      },
      clickAway () {
        this.close_on_click_away ? this.removeModal() : null
      }
    },
    mounted () {
      this._keyListener = function (e) {
        // if (e.key === 'n' && (e.ctrlKey || e.metaKey)) {
        if (e.key === 'Escape') {
          if ((e.target.tagName.toUpperCase() === 'BODY')) {
            this.removeModal()
          }
        }
      }
      document.addEventListener('keydown', this._keyListener.bind(this))
    },
    beforeDestroy () {
      document.removeEventListener('keydown', this._keyListener)
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .modal-add-sidebar .modal-container {
    display: flex;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    position: relative;
  }

  @media handheld, only screen and (max-width: 767px) {
    .modal-header {
      font-size: 0.7em;
    }

    .modal-wrapper {
      width: 100%;
      height: 100%;
    }

    .close-cross {
      top: 12px;
      right: 12px;
    }
  }

  .modal-container {
    transition: all .3s ease;
    height: 100%;
    width: 100%;
    background-color: #fff;
    color: #4e5665;
    box-shadow: -1px 1px 5px 0px rgba(50, 50, 50, 0.2);
    position: relative;
  }

  .modal-left {
    height: 100%;
  }

  @media only screen and (min-width: 767px) {
    .modal-container {
      height: 500px;
      width: 800px;
      border-radius: 3px;
    }

    .modal-add-sidebar .modal-container {
      height: 580px;
      width: 850px;
      border-radius: 3px;
    }

    .close-cross {
      top: 1rem;
      right: 1rem;
    }
  }

  .modal-header {
    background: #ffffff;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    color: #3d4340;
    border-bottom: 1px solid #d8d8d8;
    text-align: center;
    position: relative;
  }

  .close-cross {
    position: absolute;
  }

  .modal-body {
    padding: 10px 20px;
    height: calc(100% - 100px);
    overflow-y: auto;
    background: #edf0f5;
  }

  .modal-footer {
    background: #f6f9fc;
    overflow: hidden;
    border-top: 1px solid #d8d8d8;
    margin-bottom: 0;
    border-radius: 0 0 4px 4px;
    text-align: center;
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    transform: scale(0.8);
  }

  .modal-sidebar {
    margin: 0 auto;
    height: 100%;
    overflow-y: auto;
    max-height: calc(580px - 48px); /* Height of modal minus footer */
    width: 220px;
    border-left: 1px solid var(--dark-blue);
    background-color: #ffffff;
  }

  .modal-sidebar > h2 {
    margin: 20px 0;
    text-align: center;
  }

  .modal-sidebar {
    display: none;
  }

  .modal-add-sidebar .modal-left {
    width: 100%;
  }

  @media only screen and (min-width: 767px) {
    .modal-sidebar {
      display: flex;
    }

    .modal-add-sidebar .modal-left {
      width: 80%;
    }
  }
</style>



// WEBPACK FOOTER //
// Modal.vue?992b2cba